import { render, staticRenderFns } from "./Gallery14.vue?vue&type=template&id=32f2af84&scoped=true&"
import script from "./Gallery14.vue?vue&type=script&lang=js&"
export * from "./Gallery14.vue?vue&type=script&lang=js&"
import style0 from "./Gallery14.vue?vue&type=style&index=0&id=32f2af84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f2af84",
  null
  
)

export default component.exports